import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonProvider } from '../../providers/common/common';

@Component({
  selector: 'scroll-tab',
  templateUrl: 'scroll-tab.html'
})
export class ScrollTabComponent {
  @Input() tab_list = [];
  @Input() display_tyep = '1';
  @Input() scroll_id = '1';
  @Output() returnTab = new EventEmitter<number>();
  active_tab:number = 0;
  color_list = {};
  button_background:string = '#ff0000';

  constructor(
    public comProv: CommonProvider,
  ) {
    this.color_list = this.comProv.getColor();
    this.button_background = this.color_list['button_background'];
  }

  ngOnInit () {
    this.setActive();
  }

  setSwipe(direction) {
    if (direction==2) {
      if ((this.active_tab + 1) >= this.tab_list.length) {
        return;
      }
      this.changeTab(this.active_tab + 1);
    } else if(direction==4) {
      if (this.active_tab <= 0) {
        return;
      }
      this.changeTab(this.active_tab - 1);  
    }
  }

  changeTab(idx) {
    this.active_tab = idx;
    let item = document.getElementById(this.scroll_id +'_tab_' + idx);
    item.scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'});

    this.setActive();
    this.returnTab.emit(idx);
  }

  setActive() {
    // カテゴリーが２個以上の場合、選択タブのアクティブカラーを設定
    if (this.tab_list.length <= 1) {
      return;
    }
    for (let i=0; i<this.tab_list.length; i++) {
      this.tab_list[i]['is_active'] = false;
      this.tab_list[i]['color'] = '#999999';
      this.tab_list[i]['background_color'] = '#ffffff';
      this.tab_list[i]['bottom_color'] = 'transparent';

      if (i == this.active_tab) {
        this.tab_list[i]['is_active'] = true;
        this.tab_list[i]['color'] = this.button_background;
        this.tab_list[i]['background_color'] = this.comProv.getRgba(this.button_background, 0.1);
        this.tab_list[i]['bottom_color'] = this.button_background;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/scroll-tab/scroll-tab.ts